import React from 'react';
import './AIGauge.css';

interface AIGaugeProps {
  score: number;
}

const AIGauge: React.FC<AIGaugeProps> = ({ score }) => {
  const getScoreColor = (score: number) => {
    if (score <= 30) return '#4CAF50'; // Green - Low AI
    if (score <= 70) return '#FF9800'; // Orange - Medium AI  
    return '#F44336'; // Red - High AI
  };

  const getScoreLabel = (score: number) => {
    if (score <= 30) return 'Baixa probabilidade de IA';
    if (score <= 70) return 'Média probabilidade de IA';
    return 'Alta probabilidade de IA';
  };

  const circumference = 2 * Math.PI * 45;
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (score / 100) * circumference;

  return (
    <div className="ai-gauge-container">
      <div className="gauge-header">
        <h3>Análise de IA</h3>
      </div>
      
      <div className="gauge-content">
        <div className="gauge-wrapper">
          <svg className="gauge-svg" width="120" height="120" viewBox="0 0 100 100">
            {/* Background circle */}
            <circle
              cx="50"
              cy="50"
              r="45"
              fill="none"
              stroke="#e0e0e0"
              strokeWidth="8"
            />
            {/* Progress circle */}
            <circle
              cx="50"
              cy="50"
              r="45"
              fill="none"
              stroke={getScoreColor(score)}
              strokeWidth="8"
              strokeLinecap="round"
              strokeDasharray={strokeDasharray}
              strokeDashoffset={strokeDashoffset}
              transform="rotate(-90 50 50)"
              className="gauge-progress"
            />
          </svg>
          <div className="gauge-score">
            <span className="score-number">{score}</span>
            <span className="score-percent">%</span>
          </div>
        </div>
        
        <div className="gauge-info">
          <div className="score-label" style={{ color: getScoreColor(score) }}>
            {getScoreLabel(score)}
          </div>
          <div className="score-description">
            {score <= 30 && "O texto parece ter sido escrito por um humano."}
            {score > 30 && score <= 70 && "O texto pode ter sido gerado por IA."}
            {score > 70 && "O texto provavelmente foi gerado por IA."}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIGauge;